
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("2m7KJ"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("2m7KJ", function(module, exports) {

let $1b73a65a343abb5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b73a65a343abb5b$var$load("h3ABO"),
    $1b73a65a343abb5b$var$load("fSobj"),
    $1b73a65a343abb5b$var$load("74u2y"),
    $1b73a65a343abb5b$var$load("2YffH"),
    $1b73a65a343abb5b$var$load("1aTst"),
    $1b73a65a343abb5b$var$load("6mHrv"),
    $1b73a65a343abb5b$var$load("awWN9"),
    $1b73a65a343abb5b$var$load("9CYct"),
    $1b73a65a343abb5b$var$load("bLsON"),
    $1b73a65a343abb5b$var$load("cPXmn"),
    $1b73a65a343abb5b$var$load("hZtKG"),
    $1b73a65a343abb5b$var$load("iNmaF"),
    $1b73a65a343abb5b$var$load("lVO3w"),
    $1b73a65a343abb5b$var$load("hyzoX"),
    $1b73a65a343abb5b$var$load("h9Ed7"),
    $1b73a65a343abb5b$var$load("eBRUf"),
    $1b73a65a343abb5b$var$load("b2zxR"),
    $1b73a65a343abb5b$var$load("tKhaz"),
    $1b73a65a343abb5b$var$load("g2Huf"),
    $1b73a65a343abb5b$var$load("cOwGZ"),
    $1b73a65a343abb5b$var$load("cD6Zr"),
    $1b73a65a343abb5b$var$load("dtASV"),
    $1b73a65a343abb5b$var$load("kWohI"),
    $1b73a65a343abb5b$var$load("8YSo7"),
    $1b73a65a343abb5b$var$load("g7ggm"),
    $1b73a65a343abb5b$var$load("Wowvf"),
    $1b73a65a343abb5b$var$load("9S9Mz"),
    $1b73a65a343abb5b$var$load("kiGNy"),
    $1b73a65a343abb5b$var$load("7do1E"),
    $1b73a65a343abb5b$var$load("77dkW"),
    $1b73a65a343abb5b$var$load("1MlIV"),
    $1b73a65a343abb5b$var$load("g9CVe"),
    $1b73a65a343abb5b$var$load("7oiUM"),
    $1b73a65a343abb5b$var$load("8t3po"),
    $1b73a65a343abb5b$var$load("855o0"),
    $1b73a65a343abb5b$var$load("8MfZE"),
    $1b73a65a343abb5b$var$load("hv4mn"),
    $1b73a65a343abb5b$var$load("dek7I"),
    $1b73a65a343abb5b$var$load("dYtBN"),
    $1b73a65a343abb5b$var$load("6wr18"),
    $1b73a65a343abb5b$var$load("kjZZD"),
    $1b73a65a343abb5b$var$load("8iA2F"),
    $1b73a65a343abb5b$var$load("4RhJO"),
    $1b73a65a343abb5b$var$load("jsqco"),
    $1b73a65a343abb5b$var$load("851iy"),
    $1b73a65a343abb5b$var$load("37ldp"),
    $1b73a65a343abb5b$var$load("ffEVr"),
    $1b73a65a343abb5b$var$load("dRpV3"),
    $1b73a65a343abb5b$var$load("dTsOE"),
    $1b73a65a343abb5b$var$load("hhss7"),
    $1b73a65a343abb5b$var$load("jwTn5"),
    $1b73a65a343abb5b$var$load("aYdgM"),
    $1b73a65a343abb5b$var$load("6u1hm"),
    $1b73a65a343abb5b$var$load("klApM"),
    $1b73a65a343abb5b$var$load("eQgf0"),
    $1b73a65a343abb5b$var$load("8fMw3"),
    $1b73a65a343abb5b$var$load("hogcU"),
    $1b73a65a343abb5b$var$load("74vOE"),
    $1b73a65a343abb5b$var$load("7EorR"),
    $1b73a65a343abb5b$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.c35a9615.js.map
